import { render, staticRenderFns } from "./recordsItem.vue?vue&type=template&id=e131f20c&scoped=true"
import script from "./recordsItem.vue?vue&type=script&lang=js"
export * from "./recordsItem.vue?vue&type=script&lang=js"
import style0 from "./recordsItem.vue?vue&type=style&index=0&id=e131f20c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e131f20c",
  null
  
)

export default component.exports